import { Container, Section } from "@/components/ui/section";
import { FileText, Users, Code, Quote, FileSpreadsheet, Lightbulb, UserCircle, TrendingDown } from "lucide-react";

const outputs = [
  {
    icon: FileText,
    title: "Case Studies",
    description: "Website-ready narrative & metrics."
  },
  {
    icon: Users,
    title: "Customer Stories",
    description: "Human, conversational stories."
  },
  {
    icon: Code,
    title: "User Stories",
    description: "Product-focused, ready for engineering."
  },
  {
    icon: Quote,
    title: "Testimonials & Quotes",
    description: "Homepage, ads, and pricing pages."
  },
  {
    icon: FileSpreadsheet,
    title: "Sales One-Pagers",
    description: "Persona or industry-specific."
  },
  {
    icon: Lightbulb,
    title: "Insight Summaries",
    description: "Pain points, outcomes, ROI."
  },
  {
    icon: UserCircle,
    title: "Persona Snapshots",
    description: "Evolving, real customer data."
  },
  {
    icon: TrendingDown,
    title: "Win/Loss Insights",
    description: "Structured patterns from interviews."
  }
];

export const Outputs = () => {
  return (
    <Section id="outputs" className="bg-background">
      <Container>
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight">
            From a single customer interview, Casey creates multiple assets.
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {outputs.map((output, index) => (
            <div key={index} className="bg-card border border-border rounded-lg p-6 hover:shadow-[var(--shadow-soft)] transition-all duration-300">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                <output.icon className="w-5 h-5 text-primary" />
              </div>
              <h3 className="text-lg font-semibold text-foreground mb-2">
                {output.title}
              </h3>
              <p className="text-sm text-muted-foreground">
                {output.description}
              </p>
            </div>
          ))}
        </div>
      </Container>
    </Section>
  );
};
